import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
// import Link from "next/link";
import { Link } from "react-router-dom";
import { Box } from "@mui/material";

const LandingPageCards = ({ info }) => {
  return (
    <Card
      sx={{
        boxShadow: "4px 3px 2px #efefef !important",
        borderRadius: "24px",
        border: "1px solid #efefef",
        marginBottom: "0.7rem",
        height: "100%",
        backgroundColor: 'rgba(84,77,160,0.05)'
      }}
    >
      <CardContent>
        <Typography
          color="text.secondary"
          variant="h3"
          textAlign="center"
          mb={1.5}
          sx={{
//            color: "text.secondary",
      color: "rgba(221, 110, 16, .8)",
            fontWeight: "bold",
            //            height: "60%",
          }}
        >
          {info?.title}
        </Typography>
        {info?.subInfo.map((subInfo, subIndex) => (
          <Box key={subIndex} py={0.5}>
            {/* <Link href={subInfo.link}> */}
{/* <Link to={subInfo.link}> */}
          <Link to={subInfo.link}>
            {subInfo.text}
              <Typography
                color="primary"
                variant="body1"
                fontWeight={600}
                style={{
                  borderTop: "1px dashed #cccccc",
                  paddingTop: "8px",
                }}
              >
                {subInfo?.name}
              </Typography>
            </Link>
            <Typography
              component={"div"}
              color="text.primary"
              style={{
                fontSize: "11px",
              }}
              dangerouslySetInnerHTML={{ __html: subInfo?.description }}
            ></Typography>
          </Box>
        ))}
        {/* <Typography
          variant="body1"
          color="text.primary"
          mb={1}
          component={"div"}
          fontWeight={"bold"}
          dangerouslySetInnerHTML={{ __html: info }}
        ></Typography>*/}
      </CardContent>
    </Card>
  );
};

export default LandingPageCards;
